<template>
  <header class="scio-main-topbar sticky top-0 z-[9999] h-[56px] min-h-[56px] max-h-[56px] overflow-visible border-b border-neutral-200 bg-white">
    <div class="mx-auto flex h-full min-h-0 items-center gap-4 overflow-visible px-5 sm:px-6">
      <button
        type="button"
        @click="navigateTo('project-list')"
        class="group inline-flex items-center gap-3 px-1 py-2 focus:outline-none focus-visible:ring-2 focus-visible:ring-scio-yellow-p3"
      >
        <img src="/icons/scio-logo.svg" alt="Scio" class="h-8 w-auto" />
      </button>

      <nav class="ml-auto flex min-w-0 flex-nowrap items-center gap-2 overflow-visible">
        <NavButton
          label="Programmes"
          icon="/icons/scio-contracts-02.svg"
          :active="isActive('/programmes/')"
          :disabled="isDisabled"
          @click="navigateTo('project-list')"
        />

        <NavButton
          label="Catalogue"
          icon="/icons/scio-project-scenarios.svg"
          :active="isActive('/catalogue/')"
          :disabled="isDisabled"
          @click="navigateTo('catalogue')"
        />

        <div class="mx-2 hidden h-6 w-px bg-slate-200 sm:block"></div>

        <button
          type="button"
          class="relative inline-flex h-10 w-10 shrink-0 items-center justify-center border-b-2 border-transparent bg-transparent transition hover:bg-neutral-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-scio-yellow-p3 disabled:cursor-not-allowed disabled:opacity-50"
          :class="isActive('/notifications/') ? 'border-scio-yellow-p3' : ''"
          :disabled="isDisabled"
          :title="hasUnreadNotifications ? 'Notifications (unread)' : 'Notifications'"
          :aria-label="hasUnreadNotifications ? 'Notifications (unread)' : 'Notifications'"
          @click="navigateTo('notifications')"
        >
          <img src="/icons/scio-notification-bell.svg" alt="" class="h-5 w-5 opacity-80" />
          <span v-if="hasUnreadNotifications" class="absolute right-1.5 top-1.5 h-2.5 w-2.5 border-2 border-white bg-scio-yellow-p2" aria-hidden="true"></span>
        </button>

        <div class="ml-1 flex h-10 shrink-0 items-center overflow-visible" :class="isDisabled ? 'pointer-events-none opacity-50' : ''">
          <CurrentUser :isDisabled="isDisabled" />
        </div>
      </nav>
    </div>
  </header>
</template>

<script>
import CurrentUser from "@/features/users/components/CurrentUser.vue";
import NavButton from "@/common/components/ui/NavButton.vue";
import store from "@/store";

export default {
  name: "TopBar",
  components: { CurrentUser, NavButton },

  data() {
    return {
      isDisabled: false,
      hasUnreadNotifications: false,
    };
  },

  computed: {
    isLoggedIn() {
      return !!store.getters["auth/getUserId"];
    },
  },

  methods: {
    syncNotificationState() {
      this.hasUnreadNotifications = Number(localStorage.getItem("scio.notification.unreadCount") || 0) > 0;
    },

    navigateTo(routeName) {
      if (routeName === "home") {
        this.safePush({ name: this.isLoggedIn ? "project-list" : "home" });
        return;
      }

      this.safePush({ name: routeName });
    },

    safePush(target) {
      const resolved = this.$router.resolve(target);

      if (!resolved?.matched?.length) {
        console.warn("[TopBar] Route not registered", target);
        return;
      }

      if (resolved.fullPath === this.$route.fullPath) return;

      this.$router.push(target);
    },

    isActive(path) {
      return this.$route.fullPath.startsWith(path);
    },
  },
  mounted() {
    this.syncNotificationState();
    window.addEventListener("storage", this.syncNotificationState);
    window.addEventListener("scio-notifications-updated", this.syncNotificationState);
  },
  beforeUnmount() {
    window.removeEventListener("storage", this.syncNotificationState);
    window.removeEventListener("scio-notifications-updated", this.syncNotificationState);
  },
};
</script>
